import {
  type CardTransactionFilters,
  INITIAL_CARD_TRANSACTION_FILTERS,
} from "Components/CardTransactions/utils/cardTransactionFilterUtils";
import { usePersistedFilters } from "Hooks/usePersistedFilters";
import { LocalStorageKeys } from "Utils/Storage/LocalStorage/LocalStorageKeys";

const EMPTY_FILTERS: CardTransactionFilters = {};

export const useCardTransactionFilterManager = () => {
  const { filters, applyFilters } = usePersistedFilters<CardTransactionFilters>(
    {
      storageKey: LocalStorageKeys.CardTransactionFilters,
      initialFilters: INITIAL_CARD_TRANSACTION_FILTERS,
    },
  );

  const resetFilters = () => {
    applyFilters(EMPTY_FILTERS);
  };

  // "Neomezeno" (undefined timePeriod) is not counted as an active filter.
  const activeFilterCount = [
    filters.timePeriod !== undefined,
    filters.payPoint,
    filters.employee,
    filters.status,
    filters.isRefundOrCancellation === true,
  ].filter(Boolean).length;

  return {
    filters,
    activeFilterCount,
    applyFilters,
    resetFilters,
  };
};

export type CardTransactionFilterManager = ReturnType<
  typeof useCardTransactionFilterManager
>;
